import type {ReactElement} from 'react';
import React from 'react';
import {DigitalSignageSubPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/digital-signage-sub-panel/digital-signage-sub-panel';
import type {PublishingRaydiantPanelProps} from './publishing-displai-panel.types';
import {getProductUsed} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel-library';

export function PublishingDisplaiPanel({...props}: PublishingRaydiantPanelProps): ReactElement<any> {
  const productUsed = getProductUsed();

  const applicationVariablesJSON = window.PMW.util.escapeHTML(`applicationVariables={"designId":"${productUsed?.posterId}"}`);
  const raydiantExportURL = `https://dash.displai.ai/applications/4cfa0ec9-dde0-4e24-b652-5ca5b7ae8651?${applicationVariablesJSON}&utm_source=dashboard&utm_medium=app&utm_campaign=postermywall`;

  return (
    <DigitalSignageSubPanel
      onClose={props.onClose}
      panelHeading={window.i18next.t('pmwjs_raydiant')}
      heading={window.i18next.t('pmwjs_displai_digital_signage')}
      subheading={window.i18next.t('pmwjs_displai_desc')}
      imgSrc="publishing-displai.png"
      showButton
      buttonText={window.i18next.t('pmwjs_displai_connect')}
      onClick={() => {
        window.open(raydiantExportURL, '_blank');
      }}
    />
  );
}
